import { useNavigate } from 'react-router';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';
import InfoContent from '../../components/InfoContent';

export default function BillingCancelPage() {
  const navigate = useNavigate();

  return (
    <main className="relative z-10 flex min-h-screen w-full flex-1 flex-col items-center justify-between gap-10 overflow-hidden pb-5">
      <div className="flex flex-1 flex-col justify-center">
        <InfoContent
          icon={<WarningIcon className="h-100 w-100 lg:h-150 lg:w-150" />}
          title="Subscription Cancelled"
          description="Your subscription operation has been cancelled. "
          buttonLabel="Back to Dashboard"
          warn
          handleClick={() => navigate('/dashboard')}
        />
      </div>
    </main>
  );
}
